export enum BpType {
  PENDING = 'PENDING',
  OPTIMAL = 'OPTIMAL',
  NORMAL = 'NORMAL',
  ELEVATED = 'ELEVATED',
  STAGE_1 = 'STAGE_1',
  STAGE_2 = 'STAGE_2',
  STAGE_3 = 'STAGE_3',
  HYPERTENSIVE_CRISIS = 'HYPERTENSIVE_CRISIS',
}
